/**
 * @generated SignedSource<<e93aa880321834775bde5dfedce8ed39>>
 * @relayHash f854af6ffcdf9952de703a4f771a3b92
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a4f8f5f080eaef90a16f0d69caaa663e995b49dc11bfd85f0a47eb816f4c7a64

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type agentSessionsMainPaginationQuery$variables = {
  after?: string | null;
  aqlQuery: string;
  count?: number | null;
  sharingContext: string;
};
export type agentSessionsMainPaginationQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"agentSessionsMainQuery_query">;
};
export type agentSessionsMainPaginationQuery = {
  response: agentSessionsMainPaginationQuery$data;
  variables: agentSessionsMainPaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "aqlQuery"
  },
  {
    "defaultValue": 25,
    "kind": "LocalArgument",
    "name": "count"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "sharingContext"
  }
],
v1 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v2 = {
  "kind": "Variable",
  "name": "aqlQuery",
  "variableName": "aqlQuery"
},
v3 = [
  (v1/*: any*/),
  (v2/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  {
    "kind": "Variable",
    "name": "shardingContext",
    "variableName": "sharingContext"
  },
  {
    "kind": "Literal",
    "name": "sort",
    "value": "lastStateChangeAt DESC"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = {
  "kind": "ScalarField",
  "name": "name"
},
v6 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v7 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v8 = {
  "kind": "ScalarField",
  "name": "title"
},
v9 = [
  {
    "kind": "ScalarField",
    "name": "base"
  },
  {
    "kind": "ScalarField",
    "name": "webUi"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "agentSessionsMainPaginationQuery",
    "selections": [
      {
        "args": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "kind": "Variable",
            "name": "count",
            "variableName": "count"
          },
          {
            "kind": "Variable",
            "name": "sharingContext",
            "variableName": "sharingContext"
          }
        ],
        "kind": "FragmentSpread",
        "name": "agentSessionsMainQuery_query"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "agentSessionsMainPaginationQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "AgentSessionConnection",
        "kind": "LinkedField",
        "name": "agent_sessionQuery",
        "plural": false,
        "selections": [
          {
            "concreteType": "AgentSessionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "AgentSession",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "hasUnseenActivity"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "invocationType"
                  },
                  (v4/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "state"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "stateReason"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "expireTime"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "lastStateChangeAt"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "isRovo"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "agentAccountId"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "convoAiAgentId"
                  },
                  {
                    "alias": "conversationChannel",
                    "concreteType": "AgentConversationChannel",
                    "kind": "LinkedField",
                    "name": "nativeConversationChannel",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "createdAt"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "interactionChannel"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "interactionChannelAri"
                      },
                      (v5/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "lastMessage"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "lastMessageTimestamp"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "lastMessageType"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "lastAgentMessageId"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "lastAgentMessageStatus"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "readStatus"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "isPlanning"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "isPinned"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "pinnedAt"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "status"
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "name": "agent",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v5/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "picture"
                      },
                      (v4/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "name": "author",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v5/*: any*/),
                      (v4/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "name": "studioAgent",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v5/*: any*/),
                      (v4/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "name": "associatedEntities",
                    "plural": true,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v4/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "key"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "webUrl"
                          }
                        ],
                        "type": "JiraIssue"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v4/*: any*/),
                          (v8/*: any*/),
                          {
                            "concreteType": "ConfluencePageLinks",
                            "kind": "LinkedField",
                            "name": "links",
                            "plural": false,
                            "selections": (v9/*: any*/)
                          }
                        ],
                        "type": "ConfluencePage"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v4/*: any*/),
                          (v8/*: any*/),
                          {
                            "concreteType": "ConfluenceWhiteboardLinks",
                            "kind": "LinkedField",
                            "name": "links",
                            "plural": false,
                            "selections": (v9/*: any*/)
                          }
                        ],
                        "type": "ConfluenceWhiteboard"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v4/*: any*/),
                          (v8/*: any*/),
                          {
                            "concreteType": "ConfluenceDatabaseLinks",
                            "kind": "LinkedField",
                            "name": "links",
                            "plural": false,
                            "selections": (v9/*: any*/)
                          }
                        ],
                        "type": "ConfluenceDatabase"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v4/*: any*/),
                          (v8/*: any*/),
                          {
                            "concreteType": "ConfluenceSlideLinks",
                            "kind": "LinkedField",
                            "name": "links",
                            "plural": false,
                            "selections": (v9/*: any*/)
                          }
                        ],
                        "type": "ConfluenceSlide"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v4/*: any*/)
                        ],
                        "type": "Node",
                        "abstractKey": "__isNode"
                      }
                    ]
                  },
                  (v6/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "name": "cursor"
              }
            ]
          },
          {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "hasNextPage"
              },
              {
                "kind": "ScalarField",
                "name": "endCursor"
              }
            ]
          }
        ]
      },
      {
        "args": (v3/*: any*/),
        "filters": [
          "shardingContext",
          "aqlQuery",
          "sort"
        ],
        "handle": "connection",
        "key": "agentSessionsMain_agent_sessionQuery",
        "kind": "LinkedHandle",
        "name": "agent_sessionQuery"
      }
    ]
  },
  "params": {
    "id": "a4f8f5f080eaef90a16f0d69caaa663e995b49dc11bfd85f0a47eb816f4c7a64",
    "metadata": {},
    "name": "agentSessionsMainPaginationQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "66193a4651d11da28fc8f4f4ca18ca29";

export default node;
